import Loader from '@space-lib/components/loader'

import { useViewAsStore } from '@space-shell/core/store'

import { ListContainer } from './styles'

import { EmptyState, ErrorState, LoadingState, NotificationList, NotificationsHeader } from '../'
import { useNotificationInfiniteRequest } from '../../hooks/useNotificationInfiniteRequest'

const NotificationsContainer = () => {
  const { isEnabled: isViewAsEnabled } = useViewAsStore()
  const { data, isLoading, isError, isFetchingNextPage } = useNotificationInfiniteRequest()

  if (isLoading) {
    return <LoadingState />
  }

  if (isError) {
    return <ErrorState />
  }

  if (!data.pages?.[0]?.notifications?.length) {
    return <EmptyState />
  }

  return (
    <>
      <NotificationsHeader />
      <ListContainer className='_hot-scroll' isViewAsEnabled={isViewAsEnabled}>
        <NotificationList />
        {isFetchingNextPage && (
          <div className='_d-flex _justify-content-center'>
            <Loader />
          </div>
        )}
      </ListContainer>
    </>
  )
}

export default NotificationsContainer
